export default __webpack_public_path__ + "static/media/tactile_pattern.c6352baf.png";